/**
 * D4F COLLECTION TRUST BAR - DYNAMIC FEATURES
 * - Sticky Header Behavior
 * - Intersection Observer
 * - Dynamic Padding Settings
 */
(function () {
  const trustBar = document.querySelector('.d4f-trust-bar');
  if (!trustBar) return;

  // Initialisierungen
  initStickyBehavior();
  initDynamicPadding();
  initIntersectionObserver();

  /**
   * STICKY BEHAVIOR
   * Fügt Klassen beim Scrollen hinzu
   */
  function initStickyBehavior() {
    const isSticky = trustBar.dataset.sticky === 'true';
    if (!isSticky) return;

    let lastScrollTop = 0;
    let ticking = false;

    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    });

    function handleScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const trustBarRect = trustBar.getBoundingClientRect();

      // Add stuck class when trust bar reaches top
      if (trustBarRect.top <= 0) {
        trustBar.classList.add('is-stuck');
      } else {
        trustBar.classList.remove('is-stuck');
      }

      lastScrollTop = scrollTop;
    }
  }

  /**
   * DYNAMIC PADDING
   * Liest Schema-Settings und setzt CSS Custom Properties
   */
  function initDynamicPadding() {
    const section = trustBar.closest('.shopify-section');
    if (!section) return;

    // Diese Werte könnten aus den Section Settings kommen
    // Falls über data-attributes übergeben:
    const paddingTop = trustBar.dataset.paddingTop || '40';
    const paddingBottom = trustBar.dataset.paddingBottom || '40';

    document.documentElement.style.setProperty('--d4f-tb-padding-top', `${paddingTop}px`);
    document.documentElement.style.setProperty('--d4f-tb-padding-bottom', `${paddingBottom}px`);
  }

  /**
   * INTERSECTION OBSERVER
   * Animiert Items beim Erscheinen im Viewport
   */
  function initIntersectionObserver() {
    const items = trustBar.querySelectorAll('.d4f-trust-bar__item');
    if (items.length === 0) return;

    const observerOptions = {
      threshold: 0.2,
      rootMargin: '0px 0px -50px 0px',
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
        }
      });
    }, observerOptions);

    items.forEach((item) => {
      observer.observe(item);
    });
  }

  /**
   * RESPONSIVE BEHAVIOR
   * Passt Trust Bar an verschiedene Viewports an
   */
  function handleResize() {
    const width = window.innerWidth;
    
    // Optional: Spezielle Logik für verschiedene Breakpoints
    if (width < 520) {
      // Mobile specific behavior
      trustBar.classList.add('is-mobile');
    } else {
      trustBar.classList.remove('is-mobile');
    }
  }

  // Initial call
  handleResize();

  // Resize listener mit Debounce
  let resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(handleResize, 250);
  });

  /**
   * ANALYTICS TRACKING (OPTIONAL)
   * Trackt Interaktionen mit Trust Bar Items
   */
  function initTracking() {
    const items = trustBar.querySelectorAll('.d4f-trust-bar__item');

    items.forEach((item, index) => {
      item.addEventListener('click', function () {
        const text = this.querySelector('.d4f-trust-bar__text').textContent;

        // Google Analytics
        if (typeof gtag !== 'undefined') {
          gtag('event', 'trust_bar_click', {
            event_category: 'engagement',
            event_label: text,
            value: index + 1,
          });
        }

        console.log('[D4F Trust Bar] Item clicked:', text);
      });
    });
  }

  // Uncomment to enable tracking
  // initTracking();

  /**
   * ACCESSIBILITY ENHANCEMENTS
   */
  function initAccessibility() {
    const items = trustBar.querySelectorAll('.d4f-trust-bar__item');

    items.forEach((item) => {
      // Add ARIA attributes if items are interactive
      if (item.querySelector('a')) {
        item.setAttribute('role', 'link');
      } else {
        item.setAttribute('role', 'listitem');
      }
    });

    // Add ARIA label to the grid
    const grid = trustBar.querySelector('.d4f-trust-bar__grid');
    if (grid) {
      grid.setAttribute('role', 'list');
      grid.setAttribute('aria-label', 'Trust features and benefits');
    }
  }

  initAccessibility();

  /**
   * SMOOTH ENTRANCE ANIMATION
   * Triggert Entrance Animation nur beim ersten View
   */
  function initEntranceAnimation() {
    const hasAnimated = sessionStorage.getItem('d4f-trust-bar-animated');
    
    if (!hasAnimated) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-entrance');
            sessionStorage.setItem('d4f-trust-bar-animated', 'true');
            observer.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.3,
      });

      observer.observe(trustBar);
    } else {
      trustBar.classList.add('animate-entrance');
    }
  }

  initEntranceAnimation();

  console.log('[D4F Collection Trust Bar] Initialized successfully');
})();